import {
  HIDE_FUELING_PROCESS_RECEIPT_EDIT,
  SAVE_FUELING_PROCESS_RECEIPT,
  SAVE_FUELING_PROCESS_RECEIPT_FAILED,
  SHOW_FUELING_PROCESS_RECEIPT_EDIT,
} from "./constants";
import FuelingProcessesReceiptEditState from "./state";

const fuelingProcessesReceiptEditInitialState: FuelingProcessesReceiptEditState =
  {
    fuelingProcess: null,
    isModalVisible: false,
    isSaving: false,
    saveErrorCode: null,
    saveErrorMessage: null,
  };

export const fuelingProcessReceiptEditReducer = (
  state: FuelingProcessesReceiptEditState = fuelingProcessesReceiptEditInitialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): FuelingProcessesReceiptEditState => {
  switch (action.type) {
    case SHOW_FUELING_PROCESS_RECEIPT_EDIT:
      return {
        ...state,
        fuelingProcess: action.fuelingProcess,
        isModalVisible: true,
      };

    case HIDE_FUELING_PROCESS_RECEIPT_EDIT:
      return fuelingProcessesReceiptEditInitialState;

    case SAVE_FUELING_PROCESS_RECEIPT:
      return {
        ...state,
        isSaving: true,
        saveErrorCode: null,
        saveErrorMessage: null,
      };

    case SAVE_FUELING_PROCESS_RECEIPT_FAILED:
      return {
        ...state,
        isSaving: false,
        saveErrorCode: action.errorCode,
        saveErrorMessage: action.errorMessage,
      };
  }

  return state;
};
